import { gql } from "@apollo/client";

export const SURVEY_CUSTOMER_FEEDBACK = gql`
  query getSurveyCustomerFeedback {
    getSurveyCustomerFeedback {
      items {
        title,
        description,
        type,
        isRandom,
        options,
      },
    }
  }
`;
